import type { ReactNode } from 'react';

interface ChildrenProps {
  children?: ReactNode;
}

export function LegalPageBody({ children }: ChildrenProps) {
  return <div className="text-[0.938rem] leading-[1.48] text-[#111827] sm:text-[1.075rem]">{children}</div>;
}

export function LegalHeading({ children }: ChildrenProps) {
  return <h2 className="mb-[1.125rem] text-[1.063rem] font-extrabold leading-[1.15] sm:text-[1.188rem]">{children}</h2>;
}

export function LegalParagraph({ children }: ChildrenProps) {
  return <p className="mb-[1.125rem]">{children}</p>;
}

export function LegalList({ children }: ChildrenProps) {
  return <ul className="mb-[1.125rem] list-disc pl-6">{children}</ul>;
}

export function LegalOrderedList({ children }: ChildrenProps) {
  return <ol className="mb-[1.125rem] list-decimal pl-6">{children}</ol>;
}

export function LegalListItem({ children }: ChildrenProps) {
  return <li className="mb-[0.625rem]">{children}</li>;
}

export function LegalSpacer({ small = false }: { small?: boolean }) {
  return <span aria-hidden="true" className={small ? 'block h-3' : 'block h-3'} />;
}
